export const GET_SERVER_TIME_FETCH = 'GET_SERVER_TIME_FETCH';
export const GET_SERVER_TIME_FETCHING = 'GET_SERVER_TIME_FETCHING';
export const GET_SERVER_TIME_FETCH_ERROR = 'GET_SERVER_TIME_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/state/serverTime/types.js